import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
	Typography,
	Grid,
	makeStyles
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	root: {
		paddingTop: "25%",
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
	},

	h1Override: {
		fontSize: "1.85rem",
		fontWeight: 400
	},

	h2Override: {
		fontSize: "1.15rem",
		fontWeight: 400
	}
}));

function NoMatch(props) {
	let classes = styles(),
		{updateHeader, resetHeader, headline, subheading} = props;

	useEffect(() => {
		updateHeader({title: 'Whoops', primary: true});
		return () => {
			resetHeader();
		};
	}, [updateHeader, resetHeader]);

	return (
		<div className={classes.root}>
			<Grid container direction="column" alignItems="center" spacing={2}>
				<Grid item>
					<Typography className={classes.h1Override} variant="h1">{headline}</Typography>
				</Grid>
				<Grid item>
					<Typography className={classes.h2Override} variant="h2">{subheading}</Typography>
				</Grid>
			</Grid>
		</div>
	);
}

NoMatch.propTypes = {
	resetHeader: PropTypes.func.isRequired,
	updateHeader: PropTypes.func.isRequired,
	headline: PropTypes.string,
	subheading: PropTypes.string
};

export default NoMatch;
